// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ai-responsible-design.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ai-responsible-design',
  title: 'Verify responsible AI design and development process',
  description:
    'Confirm that objectives and processes for responsible AI development are established and applied (ISO/IEC 42001 Annex A.6.1.2, A.6.1.3, A.6.2.2). The process shall cover AI requirements specification, design, threat modelling and the embedding of fairness, robustness, explainability, safety and security into the AI system by design. Deviations from the objectives shall be justified and recorded. Review the responsible-AI development standard and a sample of AI-system design records.',
  category: 'technical',
  scfIds: ['SCF-AIG-005'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Responsible AI development standard is published' },
    { type: 'document-within-sla', description: 'Standard review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
